import { useRef, useEffect, useState } from "react";
import GreyDropdown from "@/assets/icons/greyDropdown.png";
import Enrolled from "@/pages/timeline/sections/timeline/timelineSections/enrolled"
import Verify from "@/pages/timeline/sections/timeline/timelineSections/verify"
import Watch from "@/pages/timeline/sections/timeline/timelineSections/watch"
import Exam from "@/pages/timeline/sections/timeline/timelineSections/exam"
import Noc from "@/pages/timeline/sections/timeline/timelineSections/noc"
import Certificate from "@/pages/timeline/sections/timeline/timelineSections/certificate"
import Tag from '@/components/common/tag/tag'
import { keyForCodeForSection } from '@/pages/timeline/sections/timeline/timelineSections/constants'
import './style.css'
import { themes } from "@/constants/colors_v2";
import { useSelector } from "react-redux";
import { RootState } from "@/store";
import { getColorCodeForTagAsPerTheme } from "@/utils";

import BlueUnFilledHeart from "@/assets/icons/blueUnFilledHeart.png";
import BlueUnFilledMan from "@/assets/icons/blueUnFilledMan.png";
import BlueUnFilledWatch from "@/assets/icons/blueUnFilledWatch.png";
import BlueUnFilledExam from "@/assets/icons/blueUnFilledExam.png";
import BlueUnfilledFile from "@/assets/icons/blueUnfilledFile.png";
import BlueUnFilledCertificate from "@/assets/icons/blueUnFilledCertificate.png";

import RedUnFilledHeart from "@/assets/icons/redUnFilledHeart.png";
import RedUnFilledMan from "@/assets/icons/redUnFilledMan.png";
import RedUnFilledWatch from "@/assets/icons/redUnFilledWatch.png";
import RedUnFilledExam from "@/assets/icons/redUnFilledExam.png";
import RedUnfilledFile from "@/assets/icons/redUnfilledFile.png";
import RedUnFilledCertificate from "@/assets/icons/redUnFilledCertificate.png";

import GreyUnFilledExam from "@/assets/icons/greyUnFilledExam.png";
import GreyUnfilledFile from "@/assets/icons/greyUnfilledFile.png";
import GreyUnFilledCertificate from "@/assets/icons/greyUnFilledCertificate.png";


import BlueUnFilledMan_darkTheme from "@/assets/icons/timelineDarkModeIcons/blueUnFilledMan_darkTheme.png"
import BlueUnFilledWatch_darkTheme from "@/assets/icons/timelineDarkModeIcons/blueUnFilledWatch_darkTheme.png"
import BlueUnFilledExam_darkTheme from "@/assets/icons/timelineDarkModeIcons/blueUnFilledExam_darkTheme.png"
import BlueUnFilledCertificate_darkTheme from "@/assets/icons/timelineDarkModeIcons/blueUnFilledCertificate_darkTheme.png"
import BlueUnfilledFile_darkTheme from "@/assets/icons/timelineDarkModeIcons/blueUnfilledFile_darkTheme.png"

import RedUnFilledMan_darkTheme from "@/assets/icons/timelineDarkModeIcons/redUnFilledMan_darkTheme.png"
import RedUnFilledWatch_darkTheme from "@/assets/icons/timelineDarkModeIcons/redUnFilledWatch_darkTheme.png"
import RedUnFilledExam_darkTheme from "@/assets/icons/timelineDarkModeIcons/redUnFilledExam_darkTheme.png"
import RedUnFilledCertificate_darkTheme from "@/assets/icons/timelineDarkModeIcons/redUnFilledCertificate_darkTheme.png"
import RedUnfilledFile_darkTheme from "@/assets/icons/timelineDarkModeIcons/redUnfilledFile_darkTheme.png"

import GreyUnFilledWatch_darkTheme from "@/assets/icons/timelineDarkModeIcons/greyUnFilledWatch_darkTheme.png"
import GreyUnFilledExam_darkTheme from "@/assets/icons/timelineDarkModeIcons/greyUnFilledExam_darkTheme.png"
import GreyUnFilledCertificate_darkTheme from "@/assets/icons/timelineDarkModeIcons/greyUnFilledCertificate_darkTheme.png"
import GreyUnfilledFile_darkTheme from "@/assets/icons/timelineDarkModeIcons/greyUnfilledFile_darkTheme.png"


import GreenUnFilledHeart from "@/assets/icons/greenUnFilledHeart.png";
import LightGreenUnFilledHeart from "@/assets/icons/lightGreenUnFilledHeart.png";
import GreenUnFilledMan from "@/assets/icons/greenUnFilledMan.png";
import GreenUnFilledWatch from "@/assets/icons/greenUnFilledWatch.png";
import GreenUnFilledExam from "@/assets/icons/greenUnFilledExam.png";
import GreenUnfilledFile from "@/assets/icons/greenUnfilledFile.png";
import GreenUnFilledCertificate from "@/assets/icons/greenUnFilledCertificate.png";


import GreenUnFilledMan_darkTheme from "@/assets/icons/timelineDarkModeIcons/greenUnFilledMan_darkTheme.png"
import GreenUnFilledWatch_darkTheme from "@/assets/icons/timelineDarkModeIcons/greenUnFilledWatch_darkTheme.png"
import GreenUnFilledExam_darkTheme from "@/assets/icons/timelineDarkModeIcons/greenUnFilledExam_darkTheme.png"
import GreenUnFilledCertificate_darkTheme from "@/assets/icons/timelineDarkModeIcons/greenUnFilledCertificate_darkTheme.png"
import GreenUnfilledFile_darkTheme from "@/assets/icons/timelineDarkModeIcons/greenUnfilledFile_darkTheme.png"

import LightBlueUnFilledHeart from "@/assets/icons/lightBlueUnFilledHeart.png";
import LightRedUnFilledHeart from "@/assets/icons/lightRedUnFilledHeart.png";



export default function SectionAccordanceView(props: any) {
    const contentRef = useRef<HTMLDivElement>(null);
    const [contentHeight, setContentHeight] = useState("0px");
    const currentTheme = useSelector((state: RootState) => state.currentThemeReducer.currentTheme);

    const colorCode: any = {
        blue: {
            lineColor: "#0073E6",
            textColor: "#0073E6"
        },
        red: {
            lineColor: "#AC1946",
            textColor: "#AC1946"
        },
        grey: {
            lineColor: "#E8E8E8",
            textColor: "#5E5E5E"
        },
        green: {
            lineColor: "#108A50",
            textColor: "#108A50"
        },

        dark_blue_theme1: {
            lineColor: "var(--blue-color4)",
            textColor: "var(--blue-color4)",
        },
        dark_red_theme1: {
            lineColor: "var(--red-color11)",
            textColor: "var(--red-color11)",
        },
        dark_grey_theme1: {
            lineColor: "var(--gray-color28)",
            textColor: "var(--gray-color28)",
        },
        dark_green_theme1: {
            lineColor: "var(--green-color)",
            textColor: "var(--green-color)",
        }
    } as const

    // console.log(props.detail)

    useEffect(() => {
        if (props.isOpen && contentRef.current) {
            setContentHeight(`${contentRef.current.scrollHeight}px`);
        } else {
            setContentHeight("0px");
        }
    }, [props.isOpen]);


    const getLineAndTextColorAsPerTheme = (source: any) => {
        if (currentTheme === themes.dark) {
            const newColorCode = getColorCodeForTagAsPerTheme(currentTheme, props.detail.colorCode, "1")
            // console.log(newColorCode, "newColorCode")
            return colorCode[newColorCode][source]
        }
        return colorCode[props.detail.colorCode][source]
    }

    const getLeftBarIconsAsPerTheme = () => {
        let currentIcon = props.detail.icon
        // console.log(props.detail.keyForCode, "todo xxpx")
        if (currentTheme === themes.dark) {
            if (props.detail.keyForCode === keyForCodeForSection.enrolled) {
                // BlueUnFilledHeart, RedUnFilledHeart
                if (currentIcon === BlueUnFilledHeart) {
                    currentIcon = LightBlueUnFilledHeart
                }
                else if (currentIcon === RedUnFilledHeart) {
                    currentIcon = LightRedUnFilledHeart
                }
                else if (currentIcon === GreenUnFilledHeart) {
                    currentIcon = LightGreenUnFilledHeart
                }
            }
            else if (props.detail.keyForCode === keyForCodeForSection.verify) {
                // BlueUnFilledMan, RedUnFilledMan
                if (currentIcon === BlueUnFilledMan) {
                    currentIcon = BlueUnFilledMan_darkTheme
                }
                else if (currentIcon === RedUnFilledMan) {
                    currentIcon = RedUnFilledMan_darkTheme
                }
                else if (currentIcon === GreenUnFilledMan) {
                    currentIcon = GreenUnFilledMan_darkTheme
                }
            }
            else if (props.detail.keyForCode === keyForCodeForSection.watch) {
                // BlueUnFilledWatch, RedUnFilledWatch
                if (currentIcon === BlueUnFilledWatch) {
                    currentIcon = BlueUnFilledWatch_darkTheme
                }
                else if (currentIcon === RedUnFilledWatch) {
                    currentIcon = RedUnFilledWatch_darkTheme
                }
                else if (currentIcon === GreenUnFilledWatch) {
                    currentIcon = GreenUnFilledWatch_darkTheme
                }
            }
            else if (props.detail.keyForCode === keyForCodeForSection.exam) {
                // BlueUnFilledExam, GreyUnFilledExam, RedUnFilledExam
                if (currentIcon === BlueUnFilledExam) {
                    currentIcon = BlueUnFilledExam_darkTheme
                }
                else if (currentIcon === GreyUnFilledExam) {
                    currentIcon = GreyUnFilledExam_darkTheme
                }
                else if (currentIcon === RedUnFilledExam) {
                    currentIcon = RedUnFilledExam_darkTheme
                }
                else if (currentIcon === GreenUnFilledExam) {
                    currentIcon = GreenUnFilledExam_darkTheme
                }
            }
            else if (props.detail.keyForCode === keyForCodeForSection.submit) {
                // RedUnfilledFile, GreyUnfilledFile, BlueUnfilledFile  
                if (currentIcon === RedUnfilledFile) {
                    currentIcon = RedUnfilledFile_darkTheme
                }
                else if (currentIcon === GreyUnfilledFile) {
                    currentIcon = GreyUnfilledFile_darkTheme
                }
                else if (currentIcon === BlueUnfilledFile) {
                    currentIcon = BlueUnfilledFile_darkTheme
                }
                else if (currentIcon === GreenUnfilledFile) {
                    currentIcon = GreenUnfilledFile_darkTheme
                }
            }
            else if (props.detail.keyForCode === keyForCodeForSection.certificate) {
                // RedUnFilledCertificate, GreyUnFilledCertificate
                if (currentIcon === BlueUnFilledCertificate) {
                    currentIcon = BlueUnFilledCertificate_darkTheme
                }
                else if (currentIcon === RedUnFilledCertificate) {
                    currentIcon = RedUnFilledCertificate_darkTheme
                }
                else if (currentIcon === GreyUnFilledCertificate) {
                    currentIcon = GreyUnFilledCertificate_darkTheme
                }
                else if (currentIcon === GreenUnFilledCertificate) {
                    currentIcon = GreenUnFilledCertificate_darkTheme
                }
            }
        }
        return currentIcon
    }

    return (
        <div className="sectionAccordanceViewMain relative mb-[5px] my500px:mb-[8px]">

            {!props.isLast && (
                <div
                    // style={{ background: colorCode[props.detail.colorCode]["lineColor"] }}
                    style={{ background: getLineAndTextColorAsPerTheme("lineColor") }}
                    className="absolute top-[40px] bottom-[-7px] left-[6px] w-0.5 transform -translate-x-1/2"></div>
            )}

            <div className="absolute top-[23px] left-[6px] transform -translate-x-1/2 -translate-y-1/2 z-10">
                <img className="accordiantSectionLeftBarIcon" src={getLeftBarIconsAsPerTheme()} alt="Blue Unfilled Heart" />
            </div>

            <button
                className={`sectionAccordanceButton w-full min-h-[37px] flex items-center justify-between pt-[10px] pl-[22px]`}
                onClick={props.onClick}
            >
                <h3
                    // style={{ color: colorCode[props.detail.colorCode]["textColor"] }}
                    style={{ color: getLineAndTextColorAsPerTheme("textColor") }}
                    className="accordiantSectionHeading font-medium">{props.detail.section}</h3>

                <div className="flex items-center">
                    {props.detail.tag &&
                        <Tag
                            text={props.detail.tag.text}
                            icon={props.detail.tag.icon}
                            // colorCode={props.detail.tag.colorCode}
                            colorCode={getColorCodeForTagAsPerTheme(currentTheme, props.detail.tag.colorCode, "1")}
                            iconWidth={props.detail.tag.iconWidth}
                            textSize={props.detail.tag.textSize}
                            borderR_tl="5px"
                            borderR_tr="5px"
                            borderR_bl="5px"
                            borderR_br="5px"
                            borderWidth="0.5px"
                            line_hight="16px"
                        />
                    }
                    <img
                        className={`ml-[10px] w-[15px] transition-transform duration-300 ${props.isOpen ? "rotate-180" : ""}`}
                        src={GreyDropdown}
                        alt="GreyDropdown"
                    />
                </div>
            </button>

            <div
                ref={contentRef}
                className="overflow-hidden transition-all duration-300"
                style={{
                    maxHeight: contentHeight
                }}
            >

                <div>
                    {props.detail.keyForCode === keyForCodeForSection.enrolled &&
                        <Enrolled />
                    }

                    {props.detail.keyForCode === keyForCodeForSection.verify &&
                        <Verify />
                    }

                    {props.detail.keyForCode === keyForCodeForSection.watch &&
                        <Watch />
                    }

                    {props.detail.keyForCode === keyForCodeForSection.exam &&
                        <Exam />
                    }

                    {props.detail.keyForCode === keyForCodeForSection.submit &&
                        <Noc />
                    }

                    {props.detail.keyForCode === keyForCodeForSection.certificate &&
                        <Certificate />
                    }
                </div>
            </div>

            <hr className="timelineAccodiantBtnSeparator ml-[22px] mt-[8px]" />
        </div>
    );
}
